import React from "react";

const languages = [
  { code: "en", label: "English" },
  { code: "fr", label: "French" },
  { code: "ar", label: "Arabic" },
  { code: "zh-CN", label: "Chinese" },
  { code: "ru", label: "Russian" },
  { code: "es", label: "Spanish" },
  { code: "ig", label: "Igbo" },
  { code: "ha", label: "Hausa" },
  { code: "yo", label: "Yoruba" },
];

function GoogleLanguageSelector() {
  const handleLanguageClick = (langCode) => {
    document.cookie = `googtrans=/en/${langCode};path=/`;
    window.location.reload();
  };

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
      {languages.map((lang, index) => (
        <span
          className="font-design lang-label"
          key={lang.code}
          onClick={() => handleLanguageClick(lang.code)}
        >
          {lang.label}
          {index < languages.length - 1 ? " |" : ""}
        </span>
      ))}
    </div>
  );
}

export default GoogleLanguageSelector;
